import React from "react"

import BookSection from "./BookSection"
import ImageSection from "./ImageSection"
import TabSection from "./TabSection"

import "./Room.scss"

const Room = (props) => {

  let gallery = []

  if ( props.acf.gallery.length > 3 ) {
    gallery = props.acf.gallery.slice(3);
  }

  return (
    <section className="room-page">
      <div className="room-page__container">
        <BookSection {...props} />
        { props.acf.gallery && <ImageSection {...props} /> }
        <TabSection {...props} />
        { gallery && gallery.map((el, i) => (
	        <section className="room-page__image-section" key={i}>
            <img src={el.localFile.childImageSharp.fluid.src} alt={el.altText} />
			    </section>
        )) }
      </div>
    </section>
  )
}

export default Room
